let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eW1Dz")).then(() => parcelRequire('5BYy0'));